module.exports = __webpack_public_path__ + "static/media/hinted-MaisonNeue-Bold.e5c993bf.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/maison/hinted-MaisonNeue-Bold.eot
// module id = 101
// module chunks = 0